import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const SalesMenuList = ({ pageName }) => {
  return (
    <>
      <div className="back-to-base">
        <i className="fas fa-chevron-double-left" />
      </div>
      <div className="sub-menu-list">
        <Link
          key="sales-dash"
          className={classNames('menu-item', 'sub-menu-item', pageName === 'EQS3' && 'highlighted')}
          to="/EQS3"
          title="Sales Dashboard"
        >
          <div className="menu-item-content">
            <i className="fas fa-tachometer-slow fa-sm fa-fw" />
            <span className="menu-label">Sales Dashboard</span>
          </div>
        </Link>
        <Link key="deals" className={classNames('menu-item', 'sub-menu-item', pageName === 'EQS2' && 'highlighted')} to="/EQS2" title="Deals">
          <div className="menu-item-content">
            <i className="fas fa-books fa-sm fa-fw" />
            <span className="menu-label">Deals</span>
          </div>
        </Link>
        <Link key="quotes" className={classNames('menu-item', 'sub-menu-item', pageName === 'EQS1' && 'highlighted')} to="/EQS1" title="Quotes">
          <div className="menu-item-content">
            <i className="fas fa-file-invoice fa-sm fa-fw" />
            <span className="menu-label">Quotes</span>
          </div>
        </Link>
        <Link key="prospects" className={classNames('menu-item', 'sub-menu-item', pageName === 'EQS5' && 'highlighted')} to="/EQS5" title="Prospective Customers">
          <div className="menu-item-content">
            <i className="fas fa-users fa-sm fa-fw" />
            <span className="menu-label">Prospective Customers</span>
          </div>
        </Link>
      </div>
    </>
  );
};

export default SalesMenuList;
